import React from "react";
import styled from "styled-components";
import AppHeader from "./AppHeader";
import { MdCancel, MdMonetizationOn, MdErrorOutline, MdSecurity } from "react-icons/md";

const PageContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 50px;
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 30px auto;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #2d3748;
`;

const Title = styled.h1`
  color: #1a202c;
  font-size: 2rem;
  margin-bottom: 10px;
`;

const Subtitle = styled.p`
  color: #718096;
  font-weight: 500;
  margin-bottom: 30px;
`;

const PolicySection = styled.div`
  margin-bottom: 25px;
  padding: 20px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #edf2f7;
`;

const SectionHeader = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a73e8;
  margin-top: 0;
  margin-bottom: 15px;
`;

const PolicyText = styled.div`
  line-height: 1.7;
  color: #4a5568;
  font-size: 15px;

  ul {
    padding-left: 20px;
    margin-top: 10px;
  }
  
  li {
    margin-bottom: 8px;
  }
`;

const CancellationRefund = () => {
  return (
    <PageContainer>
      <AppHeader />
      <ContentWrapper>
        <Title>Cancellation & Refund Policy</Title>
        <Subtitle>For future Subscription and Premium Business Services.</Subtitle>

        <PolicySection>
          <SectionHeader><MdMonetizationOn size={24}/> Subscription Model</SectionHeader>
          <PolicyText>
            We offer monthly and annual subscription plans for "Verified Business Pages" and "Featured Job Postings."
          </PolicyText>
        </PolicySection>

        <PolicySection>
          <SectionHeader><MdCancel size={24}/> Cancellation</SectionHeader>
          <PolicyText>
            Users can cancel their subscription at any time via the "Plan Management" section. Access to premium features will continue until the end of the current billing cycle.
          </PolicyText>
        </PolicySection>

        <PolicySection>
          <SectionHeader><MdErrorOutline size={24}/> Refunds</SectionHeader>
          <PolicyText>
            <strong>Digital Services:</strong> As our services provide immediate digital "Supply Power" (visibility and access), payments are generally non-refundable.
            <br/><br/>
            <strong>Exceptional Cases:</strong> If a technical error on our part prevents service delivery for more than 48 hours, a pro-rata refund may be initiated upon request to <strong>support@avaami.com</strong>.
          </PolicyText>
        </PolicySection>

        <PolicySection>
          <SectionHeader><MdSecurity size={24}/> Termination</SectionHeader>
          <PolicyText>
            Avaami Technologies reserves the right to cancel subscriptions without refund if a user violates the Professional Conduct guidelines.
          </PolicyText>
        </PolicySection>

      </ContentWrapper>
    </PageContainer>
  );
};

export default CancellationRefund;